// Visualization Base (researcher-only "Base" section) — restricts the eligible
// respondent pool for a chart's data using AND-joined conditions built from
// stable question/variable/value IDs (never labels, which can change).
// Shared across chart types (bar, and eventually others) since the underlying
// condition-building UI, validation, and /search filter transform are all
// chart-agnostic — only the Redux slice each chart type stores it in differs.
export type VisualizationBaseQuestionType = "single" | "multi";

export interface VisualizationBaseCondition {
  id: string;
  questionId: string;
  questionType: VisualizationBaseQuestionType;
  // Multiple: selected variable IDs. Single grid: row-variable IDs (paired with valueIds).
  variableIds: string[];
  // Single: selected value IDs. Single grid: column-value IDs (paired with variableIds).
  valueIds: string[];
}

export interface VisualizationBase {
  enabled: boolean;
  name: string;
  conditions: VisualizationBaseCondition[];
}

export const DEFAULT_VISUALIZATION_BASE: VisualizationBase = {
  enabled: false,
  name: "",
  conditions: [],
};
